// Pure SPA-navigation helpers used by tree rows, workspace switcher rows,
// and other surfaces that render real <a href> elements. Consumed by
// `app.jsx` through `window.mindexSpaNav` (attached by vendor.entry.js so
// the global exists before app.js runs). Mirrors the workspace-switcher.js
// pattern.

// True for clicks that should fall through to the browser's native link
// behavior (open in new tab/window, etc.). SPA link onClick handlers
// must early-return on this so middle/cmd/ctrl/shift clicks still work.
export function isModifiedClick(e) {
  return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0;
}

// Build a URL from the (org, ws, file) tuple. Each segment is
// individually percent-encoded so a file path containing '/' survives.
export function buildRoute({ orgSlug, wsHandle, filePath }) {
  if (!orgSlug) return '/';
  const parts = [encodeURIComponent(orgSlug)];
  if (wsHandle) {
    parts.push(encodeURIComponent(wsHandle));
    if (filePath) {
      for (const seg of filePath.split('/')) {
        if (seg) parts.push(encodeURIComponent(seg));
      }
    }
  }
  return '/' + parts.join('/');
}
